import React, { useEffect, useState, useRef } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import parse from "html-react-parser";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

const SponsorSection = ({ webpageData }) => {
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";
  const sponsorData = webpageData?.sponsorSection || {};
  const sponsors = sponsorData?.sponsors || [];
  const [userLocation, setUserLocation] = useState("unknown");
  const searchParams = new URLSearchParams(window.location.search);
  const nftText = searchParams.get("nft");
  const carouselRef = useRef(null);
  const [isAutoplay, setIsAutoplay] = useState(true);
  const autoplayTimerRef = useRef(null);
  const isDesktop = window.innerWidth > 600;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_MAXMIND,
          {},
          {
            headers: { "Content-Type": "application/json" },
            timeout: 5000,
          }
        );
        if (
          response.data !== "IP Not Available" &&
          response.data !== "Invalid Country"
        ) {
          setUserLocation(JSON.stringify(response.data));
        } else {
          setUserLocation("User is not from US");
        }
      } catch (error) {

      }
    };
    fetchData();
  }, []);

  const incrementPdfCount = async () => {
    const webpageName = "https://www.ussaic.com";
    const filePath = sponsorData?.ctaBanner?.buttonUrl
      ? new URL(sponsorData.ctaBanner.buttonUrl, window.location.origin).pathname
      : "unknown";
    try {
      await fetch(process.env.REACT_APP_DOWNLOADCOUNT_LAMBDA_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ webpageName, userLocation, filePath })
      });
    } catch (error) {

    }
  };

  const getSponsorClass = (name) => {
    if (name === "Angel AI") return "angel-ai-logo";
    if (name === "American Bussiness Media") return "abm-logo";
    if (name === "Liquid Manzana") return "liquid-manzana-logo";
    return "";
  };

  const rowRef = useRef(null);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

// useEffect(() => {
//   if (isIOS && rowRef.current) {
//     rowRef.current.style.animation = "none";
//   }
// }, []);

  const handleMouseEnter = () => {
    rowRef.current.style.animationPlayState = "paused";
  };

  const handleMouseLeave = () => {
    rowRef.current.style.animationPlayState = "running";
  };

  const duplicateCardList = () => {
    const cardList = sponsorData?.sponsors;
    return [...cardList, ...cardList, ...cardList, ...cardList, ...cardList, ...cardList];
  };

  const restartAutoplayAfterDelay = () => {
    if (autoplayTimerRef.current) clearTimeout(autoplayTimerRef.current);
    autoplayTimerRef.current = setTimeout(() => {
      setIsAutoplay(true);
      carouselRef.current?.slickPlay();
    }, 3000);
  };

  const getSliderSpeedSettings = () => {
    const width = window.innerWidth;
  
    if (width <= 576) {
      return { speed: 5000, autoplaySpeed: 1000 };
    } else if (width <= 768) {
      return { speed: 7000, autoplaySpeed: 1000 };
    }
  
    return { speed: 10000, autoplaySpeed: 1000 };
  };


  const { speed, autoplaySpeed } = getSliderSpeedSettings();

  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: isAutoplay,
  speed,
  autoplaySpeed,
    slidesToShow: isDesktop ? 4 : 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    cssEase: "linear",
    draggable: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    swipe: true,
    touchMove: true,
    beforeChange: () => {},
    afterChange: restartAutoplayAfterDelay,
    onSwipe: () => {
      setIsAutoplay(false);
      carouselRef.current?.slickPause();
    },
    onTouchStart: () => {
      setIsAutoplay(false);
      carouselRef.current?.slickPause();
    },
    onTouchEnd: restartAutoplayAfterDelay,
    responsive: [
      { breakpoint: 3000, settings: { slidesToShow: 4 } },
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
    ]
  };

  return (
    <section className="sponsor-section" id="next-section">
      {!nftText && (
        <div className="banner-ai-crypto">
          <p>
            Uniting Policy &amp; Business Leaders to {" "}
            <span style={{ fontWeight: 900 }}>Make America First</span> in AI &amp; Crypto
          </p>
        </div>
      )}

      <Container>
        <Row className="justify-content-center">
          <Col xs={12}>
            {/* <Slider {...sliderSettings} ref={carouselRef} className="sponsor-carousel"> */}

            <div className="team-section-container">

        <div
          className="team-section horizontal-scroll"
          ref={rowRef}
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}

        >
          <div className="influencer-section">
              {duplicateCardList().map((sponsor, index) => (
                <div className="sponsor-carousel-item text-center" key={index}>
                  {sponsor.link ? (
                    <a href={sponsor.link} target="_blank" rel="noopener noreferrer">
                      <Image
                        src={imgCDNURL + sponsor.src}
                        alt={sponsor.alt || sponsor.name}
                        className={`sponsor-logo ${getSponsorClass(sponsor.name)}`}
                        {...(isIOS ? {} : { loading: "lazy" })}
                      />
                    </a>
                  ) : (
                    <Image
                      src={imgCDNURL + sponsor.src}
                      alt={sponsor.alt || sponsor.name}
                      className={`sponsor-logo ${getSponsorClass(sponsor.name)}`}
                      {...(isIOS ? {} : { loading: "lazy" })}
                    />
                  )}
                </div>
              ))}
            {/* </Slider> */}
            </div>
        </div>
     
      </div>
          </Col>
        </Row>

        {sponsorData?.ctaBanner && (
          <Row className="justify-content-center">
            <Col xs={12}>
              <div className="banner-container-sponsor">
                <div className="banner-content-sponsor">
                  <div className="sponsor-cta-content">
                    <h2 className="sponsor-cta-title">
                      {parse(sponsorData.ctaBanner.title || "")}
                    </h2>
                    <p className="sponsor-cta-text">
                      {parse(sponsorData.ctaBanner.text || "")}
                    </p>
                    {sponsorData.ctaBanner.buttonText && (
                      <Button
                        variant="light"
                        className="sponsor-cta-button"
                        href={
                          sponsorData.ctaBanner.buttonUrl
                            ? imgCDNURL + sponsorData.ctaBanner.buttonUrl
                            : undefined
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={incrementPdfCount}
                      >
                        {sponsorData.ctaBanner.buttonText}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </section>
  );
};

export default SponsorSection;